// AB1 — Alan boyutu (kullanıcı bazlı): normal | kucuk. Hesapta Kullanici.AlanBoyutu
// (NULL/0 = normal, 1 = küçük). Küçükte <html>'e `hepy-kucuk` sınıfı eklenir; form alanı,
// düğme ve tablo token'ları assets/alan-boyutu.css'te küçük karşılıklarına bağlanır.
// Dışarı açık sayfalar her zaman normal (normalZorla — kaydetmez, tema.js acikZorla deseni).

import depo from './depo';
import { uiState } from "./uiState";

const LS_KEY = "hepyAlanBoyutu";
const SINIF = "hepy-kucuk";

// DB AlanBoyutu → tercih (null, 0 ya da tanınmayan değer = normal)
export function boyutDbden(v) {
  return v === 1 || v === "1" || v === true ? "kucuk" : "normal";
}

// tercih → DB AlanBoyutu
export function boyutDbye(b) {
  return b === "kucuk" ? 1 : 0;
}

function sinifUygula(b) {
  const el = document.documentElement;
  if (b === "kucuk") el.classList.add(SINIF);
  else el.classList.remove(SINIF);
}

// Tercihi uygula ve localStorage'a yaz.
export function boyutUygula(b) {
  const n = b === "kucuk" ? "kucuk" : "normal";
  sinifUygula(n);
  uiState.alanBoyutu = n;
  try {
    depo.yaz(LS_KEY, n);
  } catch (e) { /* yoksay */ }
}

// Public rotada kaydetmeden normal göster (panelin kayıtlı tercihi silinmesin).
export function normalZorla() {
  sinifUygula("normal");
}

export function kayitliBoyut() {
  try {
    return depo.oku(LS_KEY) === "kucuk" ? "kucuk" : "normal";
  } catch (e) {
    return "normal";
  }
}
